import BottomMenuCasino from "../components/BottomMenuCasino";
import CommunityPageHeader from "../components/CommunityPageHeader";
import editNameImage from '../img/edit_name.png'

import '../css/profile_page.css'
import { useEffect, useRef, useState } from "react";
import { useNavigate } from "react-router-dom";
import UserImageRound from "../helpers/UserImage";
import defaultUserImage from '../img/default_user_image.png'
import { changeUserNameRequest } from "../helpers/requests";


function ProfilePage({activeSubcategory, setActiveSubcategory, countryName, activeCommunitySubcategory, setActiveCommunitySubcategory, phoneNumber, userName, userImage, userId, setUserName}){
    const inputRef = useRef(null);
    const navigate = useNavigate()
    const [inputValue, setInputValue] = useState('')

    useEffect(() => {
        setActiveSubcategory('Сообщество')
        setActiveCommunitySubcategory('Чат')
    }, [])

    useEffect(() => {
        setInputValue(userName);
    }, [userName])

    const editImageContainerHandleClick = () => {
        if (inputRef.current) {
            inputRef.current.focus()
        }
    };

    const changeUserName = () => {
        if (inputValue !== userName && inputValue !== '') {
            changeUserNameRequest(userId, inputValue);
            setUserName(inputValue);
        }
    }

    return <div className="profile-page">
            <CommunityPageHeader countryName={countryName} activeCommunitySubcategory={activeCommunitySubcategory} setActiveCommunitySubcategory={setActiveCommunitySubcategory} phoneNumber={phoneNumber}/>
            <div className="profile-page-name-input-section">
                <input className="profile-page-name-input" ref={inputRef} value={inputValue} onChange={(e) => setInputValue(e.target.value)} onBlur={changeUserName}/>
                <div className="profile-page-name-input-edit-image-container" onClick={editImageContainerHandleClick}>
                    <img className="profile-page-name-input-edit-image" src={editNameImage} alt='error'/>
                </div>
            </div>
            <div className="profile-page-user-image-container" onClick={() => {navigate(`/user-images?phone=${phoneNumber}`)}}>
                <UserImageRound className="profile-page-user-image" src={userImage?.image} alt='error' fallbackSrc={defaultUserImage}/>
            </div>
            <div className="profile-page-user-id-container">
                <div className="profile-page-user-id">ID {userId}</div>
            </div>
            <BottomMenuCasino activeSubcategory={activeSubcategory} setActiveSubcategory={setActiveSubcategory} countryName={countryName} phoneNumber={phoneNumber}/>
        </div>
};

export default ProfilePage;